import { useTranslation } from 'react-i18next'
import type { CatalogSupplierOnboardingStatus } from '@/shared/hooks/api/catalog'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

type V2CatalogSupplierFunnelStatusCellProps = {
  onboardingStatus: CatalogSupplierOnboardingStatus
  magicLinkFirstOpenedAt: string | null
  requestAcknowledgedAt: string | null
}

function funnelStageLabelKey(
  status: CatalogSupplierOnboardingStatus
): `v2.pages.suppliers.onboardingStatus.${CatalogSupplierOnboardingStatus}` {
  return `v2.pages.suppliers.onboardingStatus.${status}`
}

function formatFunnelDate(value: string, language: string): string {
  const locale = language.startsWith('zh') ? 'zh-CN' : 'en-GB'
  return new Date(value).toLocaleString(locale)
}

export function V2CatalogSupplierFunnelStatusCell({
  onboardingStatus,
  magicLinkFirstOpenedAt,
  requestAcknowledgedAt,
}: V2CatalogSupplierFunnelStatusCellProps) {
  const { t, i18n } = useTranslation('common')
  const label = t(funnelStageLabelKey(onboardingStatus))

  if (onboardingStatus === 'INVITE_SENT') {
    return <span>{label}</span>
  }

  let tooltip = label
  if (
    onboardingStatus === 'INVITE_OPENED' &&
    magicLinkFirstOpenedAt != null
  ) {
    tooltip = formatFunnelDate(magicLinkFirstOpenedAt, i18n.language)
  } else if (
    onboardingStatus === 'ACKNOWLEDGED' &&
    requestAcknowledgedAt != null
  ) {
    tooltip = formatFunnelDate(requestAcknowledgedAt, i18n.language)
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="cursor-default">{label}</span>
      </TooltipTrigger>
      <TooltipContent side="top">{tooltip}</TooltipContent>
    </Tooltip>
  )
}
